import styled, { css } from 'styled-components';
import { LolloBernie } from './LolloBernie.style.js';
import { ConceptBadge } from '../../ConceptBadge/ConceptBadge.style.js';
import { isGlobetrotter } from '../../../utils/theming.js';
import mq from '../../../utils/mediaQueries.js';

// @ts-nocheck
var CardImage = styled.div.withConfig({
  displayName: "CardImagestyle__CardImage",
  componentId: "sc-1n46i67-0"
})(["background-color:var(--color-grey-200);grid-area:image;overflow:hidden;position:relative;", ""], function (_ref) {
  var $sizes = _ref.$sizes;
  return css([".uikit-picture--broken{", "}"], $sizes.map(function (size) {
    return css(["", ""], size.breakpoint ? css(["@media (min-width:", "px){aspect-ratio:", ";min-height:100%;}"], size.breakpoint, size.ar) : css(["aspect-ratio:", ";min-height:100%;"], size.ar));
  }));
});
styled.a.withConfig({
  displayName: "CardImagestyle__LinkLayer",
  componentId: "sc-1n46i67-1"
})(["display:flex;cursor:pointer;width:100%;height:100%;position:relative;"]);
var CardImageOverlay = styled.div.withConfig({
  displayName: "CardImagestyle__CardImageOverlay",
  componentId: "sc-1n46i67-2"
})(["position:absolute;z-index:1;inset:var(--space-400);", " ", "{position:absolute;bottom:calc(-1 * var(--space-500));right:0;", "}", "{position:absolute;", "}"], mq.s(css(["inset:var(--space-500);"])), LolloBernie, isGlobetrotter(css(["display:none;"])), ConceptBadge, isGlobetrotter(css(["display:none;"])));
var Picture = styled.picture.withConfig({
  displayName: "CardImagestyle__Picture",
  componentId: "sc-1n46i67-3"
})(["&,img{align-self:center;flex:0 0 auto;height:100%;max-width:none;width:100%;object-fit:cover;}"]);

export { CardImage, CardImageOverlay, Picture };
//# sourceMappingURL=CardImage.style.js.map
